import { Geometry } from 'geojson'
import { ParcelleJson } from 'interfaces/Parcelle'
import SellHistory from './SellHistory'
import Point from './Point'

export enum ParcelleType {
  Simple = 'simple',
  Multi = 'multi',
}

class Parcelle {
  private _uid: string

  private _swimmingPool: boolean

  private _surfaceTerrain: number

  private _address: string

  private _batiList: number[]

  private _historique: SellHistory[]

  private _centre: Point

  private _geographie: Geometry

  private _parcelleType: ParcelleType

  private _favori: {
    createdAt: Date
    urlAnnonce: string
    commentaire: string
  } | null

  constructor(parcelle: ParcelleJson) {
    this._uid = parcelle.parcelleUid
    this._geographie = parcelle.parcelleGeography
    this._surfaceTerrain = parcelle.parcelleAire
    this._address = parcelle.parcelleAdresse
    this._batiList = parcelle.bati
    this._centre = parcelle.parcelleCentre
    this._swimmingPool = parcelle.parcellePiscine
    this._parcelleType = parcelle.parcelleWithBatiUnique
      ? ParcelleType.Simple
      : ParcelleType.Multi
    this._historique = parcelle.dvf.map((history) => new SellHistory(history))
    this._favori = parcelle.favori
  }

  get swimmingPool(): boolean {
    return this._swimmingPool
  }

  get surfaceTerrain(): number {
    return this._surfaceTerrain
  }

  get address(): string {
    return this._address
  }

  get batiList(): number[] {
    return this._batiList
  }

  get historique(): SellHistory[] {
    return this._historique
  }

  get uid(): string {
    return this._uid
  }

  get centre(): Point {
    return this._centre
  }

  get geographie(): Geometry {
    return this._geographie
  }

  get favori(): {
    createdAt: Date
    urlAnnonce: string
    commentaire: string
  } | null {
    return this._favori
  }

  get parcelleType(): ParcelleType {
    return this._parcelleType
  }

  get parcelleTitle(): string {
    return `Bien ${this._address}`
  }
}

export default Parcelle
